var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useContext } from 'react';
import { getFilteredModels, getTrimFilterValues } from '../../ModelFiltersContext/utils';
import { ModelFiltersContext } from '../../ModelFiltersContext';
import { getAllTrimsFromModelData } from './utils';
import { mapOffersToModelsWithPrice } from '../special_offers_filter/utils';
/**
 * @param {Object} filter - filter object
 * @param {String} category - filter category
 * @param {String} item - filter item
 * @param {Object} modelData - from Sitecore route
 * @returns true if no filtered trims have the specified item
 */
var useIsFilterItemDisabled = function (modelData) {
    var modelFiltersContext = useContext(ModelFiltersContext);
    var offersResponse = (modelFiltersContext || {}).offersResponse;
    var allTrims = getAllTrimsFromModelData(modelData);
    var allTrimsWithOffers = mapOffersToModelsWithPrice(allTrims, offersResponse.data);
    return function (filter, category, item) {
        var _a;
        var _b, _c, _d;
        if (typeof window === 'undefined')
            return false;
        if ((filter === null || filter === void 0 ? void 0 : filter.onlyFutureVehicles) || (filter === null || filter === void 0 ? void 0 : filter.onlyNsx))
            return true;
        var allTrimsWithFilterValues = allTrimsWithOffers === null || allTrimsWithOffers === void 0 ? void 0 : allTrimsWithOffers.map(function (trim) { return (__assign(__assign({}, trim), { filterValues: getTrimFilterValues(trim) })); });
        var filteredTrims = getFilteredModels(allTrimsWithFilterValues, filter === null || filter === void 0 ? void 0 : filter.values);
        var trimCountForFilterItem = (_d = getFilteredModels(filteredTrims, __assign(__assign({}, filter === null || filter === void 0 ? void 0 : filter.values), (_a = {}, _a[category] = (_c = (_b = filter === null || filter === void 0 ? void 0 : filter.values) === null || _b === void 0 ? void 0 : _b[category]) === null || _c === void 0 ? void 0 : _c.concat(item), _a)))) === null || _d === void 0 ? void 0 : _d.length;
        return trimCountForFilterItem === 0;
    };
};
export default useIsFilterItemDisabled;
